import type { RefObject } from 'react';

import { createTableHookContexts } from '@tanstack/react-table';
import { createContext, use } from 'react';

import type { AppTableFeatures } from './Table.hooks';

export const { tableContext, useTableContext } = createTableHookContexts<AppTableFeatures>();

/** Points at the top of the table, so pagination can bring it back into view. */
export const TableScrollTargetContext = createContext<RefObject<HTMLDivElement | null> | null>(null);

export const useTableScrollTarget = () => use(TableScrollTargetContext);
